import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GlobalTemplateConfigurationsChanged } from './global-configurations.actions';

export interface GlobalConfigurationsStateModel {
   globalTemplateId?: number;
}
@State<GlobalConfigurationsStateModel>({
   name: 'globalTemplateConfigurations',
   defaults: {
      globalTemplateId: null,
   },
})
@Injectable()
export class GlobalConfigurationsState {
   @Selector([GlobalConfigurationsState])
   public static defaultTemplateId(state: GlobalConfigurationsStateModel): number {
      return state.globalTemplateId;
   }

   @Action(GlobalTemplateConfigurationsChanged)
   public GetGlobalConfigurations(ctx: StateContext<GlobalConfigurationsStateModel>, action: GlobalTemplateConfigurationsChanged) {
      ctx.patchState({
         globalTemplateId: action?.data.defaultTemplateId,
      });
   }
}
